import { useQuery } from "@tanstack/react-query"
import { apiClient } from "../helpers/Axios"

export const useShippingCosts = () => {
    return useQuery({
        queryKey: ['shipping-cost'],
        queryFn: async () => {
            const res = await apiClient.get('/shop/shipping-cost');
            return res.data
        },
        refetchOnWindowFocus: false
    })
}